import { render, staticRenderFns } from "./RegisterDepartment.vue?vue&type=template&id=198ced15&scoped=true&"
import script from "./RegisterDepartment.vue?vue&type=script&lang=ts&"
export * from "./RegisterDepartment.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterDepartment.vue?vue&type=style&index=0&id=198ced15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ced15",
  null
  
)

export default component.exports